import * as st from './heroshot.module.scss'
import * as React from 'react'
import { CirclePlayButton } from '../circlePlayButton/circlePlayButton'
import { CirclePlayButtonPlaceholder } from '../circlePlayButton/circlePlayButtonPlaceholder'
import { Packshot } from './packshot'
import { ResponsiveImage } from '../images/responsiveImage'
import { SrcSize } from '../../utils/imageUtils'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { DetailPageActions } from '../../actions'
import { PlaybackContentLink } from '@shared'
import { startPlayback } from '../../actions/player'
import { IDetailPageState } from '../../reducers'
import { isTVSelector } from '../../selectors/shared'
import { sessionIdSelector, isRetailSelector, marketplaceIdSelector } from '../../selectors/requestContext'
import { simpleSelectors } from '../../selectors/basicState'
import { isDeeplinkableActionReadySelector } from '../../selectors/pageContext'
import { imagesSelector } from '../../selectors/detailFragment'
import { playbackFirstChildSelector } from '../../selectors/actionFragment'
import { isJPMarketplace } from '../../utils/marketplace'

const HEROSHOT_MOBILE_WIDTH = 360
const HEROSHOT_TABLET_WIDTH = 720
const HEROSHOT_DESKTOP_WIDTH = 1080

type StateProps = ReturnType<typeof mapStateToProps>
type DispatchProps = ReturnType<typeof mapDispatchToProps>
export type Props = StateProps & DispatchProps

export const ConnectedHeroshot = ({ images, marketplaceId, playbackData, sessionId, pageTitleId, isRetail, isTV, isDeeplinkableActionReady, startPlayback, usePlayer }: Props) => {
  if (!images) {
    return null
  }

  const heroshot = !isJPMarketplace(marketplaceId) && images.heroshot // Force no heroshot in jp
  const packshot = images.packshot


  if (!heroshot) {
    return (
      <Packshot
        packshot={packshot}
        playbackData={playbackData}
        sessionId={sessionId}
        pageTitleId={pageTitleId}
        isRetail={isRetail}
        isTV={isTV}
        startPlayback={startPlayback}
        usePlayer={usePlayer}
      />
    )
  }

  const heroshotImgProps = {
    alt: '', // Decorative image so no alt
    src: heroshot,
    baseValue: HEROSHOT_DESKTOP_WIDTH,
    srcSizes: [
      { 'max-phablet': HEROSHOT_MOBILE_WIDTH },
      { 'max-tablet': HEROSHOT_TABLET_WIDTH },
      {'min-tablet': HEROSHOT_DESKTOP_WIDTH}
    ] as SrcSize[]
  }

  return (
    <React.Fragment>
      <div className={`${st.avHeroBackground} ${st.heroshotOpacity} av-hero-background`}
           data-automation-id="hero-background">
        <div className={st.imageFadeWrapper}>
          <ResponsiveImage className={`${st.heroshot}`} {...heroshotImgProps} />
          <div className={st.avHeroBackgroundFadeLeft}/>
          <div className={st.avHeroBackgroundFadeBottom}/>
        </div>
        {isRetail && (
          <div className="playback-large-circle-wrapper">
            <div id="dv-play-box-circle">
              {isDeeplinkableActionReady && playbackData && (
                <CirclePlayButton playbackData={playbackData} sessionId={sessionId} pageTitleId={pageTitleId} startPlayback={startPlayback} usePlayer={usePlayer}/>
              )}
            </div>
          </div>
        )}
      </div>
      <CirclePlayButtonPlaceholder />
    </React.Fragment>
  )
}


const mapStateToProps = (state: IDetailPageState) => ({
  sessionId: sessionIdSelector(state),
  pageTitleId: simpleSelectors.pageTitleId(state),
  isRetail: isRetailSelector(state),
  isTV: isTVSelector(state),
  isDeeplinkableActionReady: isDeeplinkableActionReadySelector(state),
  marketplaceId: marketplaceIdSelector(state),
  images: imagesSelector(state),
  playbackData: playbackFirstChildSelector(state),
  usePlayer: Boolean(state.features.usePlayer)
})

const mapDispatchToProps = (dispatch: Dispatch<DetailPageActions>) => ({
  startPlayback: (playbackContentLink: PlaybackContentLink) =>
    dispatch(startPlayback(playbackContentLink))
})

export const Heroshot = connect(mapStateToProps, mapDispatchToProps)(ConnectedHeroshot)